import { ReactElement } from 'react'

import BuscarContatos from '../../domain/usecases/BuscarContatos'
import ContatoRepository from '../../infra/repositories/ContatoRepository'
import DetalhesFaleConosco from '../../pages/DetalhesFaleConosco'

export const FaleConoscoFactory = (): ReactElement => {
  const contatoRepository = new ContatoRepository()
  const buscarContato = new BuscarContatos(contatoRepository)

  return <DetalhesFaleConosco getContatos={buscarContato} />
}
